import httpMethod from 'services/update2025/httpMethod';
import BlockDetail from "components/block-detail/BlockDetail";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { TabPanel, TabView } from "primereact/tabview";
import { Toast } from "primereact/toast";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { bhxh, bhyt, dkyxe, findApprovalResultByDocType, gplx, mst } from "services/ApprovalResultService";
import { X_TOTAL_COUNT } from "utils/constants";
import { handleError } from "utils/handleError";
import { ApprovalResultContext } from "./ApprovalResultContext";

export const ApprovalResultList = () => {
    const toast = useRef(null);
    const dt = useRef(null);
    const { t, i18n } = useTranslation(["approval-result", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const trangThais = [
        { label: "Chờ gửi", value: "0" },
        { label: "Gửi thành công", value: "1" },
        { label: "Gửi thất bại", value: "2" },
        { label: "Gửi lại", value: "3" },
    ];

    const approvalResultses = [
        { label: "Không đạt", value: "0" },
        { label: "Đạt", value: "1" },
    ];

    const approvalResultContext = useContext(ApprovalResultContext);
    const {
        approvalResultbhxh,
        setApprovalResultbhxh,
        approvalResultgplx,
        setApprovalResultgplx,
        approvalResultdkyxe,
        setApprovalResultdkyxe,
        approvalResultmst,
        setApprovalResultmst,
        approvalResultbhyt,
        setApprovalResultbhyt,
        approvalResultbhxhs,
        setApprovalResultbhxhs,
        approvalResultgplxs,
        setApprovalResultgplxs,
        approvalResultdkyxes,
        setApprovalResultdkyxes,
        approvalResultmsts,
        setApprovalResultmsts,
        approvalResultbhyts,
        setApprovalResultbhyts,
    } = approvalResultContext;

    const [totalRecordbhxhs, setTotalRecordbhxhs] = useState(0);
    const [totalRecordbhyts, setTotalRecordbhyts] = useState(0);
    const [totalRecorddkyxes, setTotalRecorddkyxes] = useState(0);
    const [totalRecordgplxs, setTotalRecordgplxs] = useState(0);
    const [totalRecordthuecns, setTotalRecordthuecns] = useState(0);

    const [checkLoadbhxh, setCheckLoadbhxh] = useState(false);
    const [checkLoadbhyt, setCheckLoadbhyt] = useState(false);
    const [checkLoaddkyxe, setCheckLoaddkxe] = useState(false);
    const [checkLoadgplx, setCheckLoadgplx] = useState(false);
    const [checkLoadthuecn, setCheckLoadthuecn] = useState(false);

    const [submitbhxh, setSubmitbhxh] = useState(false);
    const [submitbhyt, setSubmitbhyt] = useState(false);
    const [submitdkyxe, setSubmitdkxe] = useState(false);
    const [submitgplx, setSubmitgplx] = useState(false);
    const [submitthuecn, setSubmitthuecn] = useState(false);

    const [dataSearchbhxh, setDataSearchbhxh] = useState({
        first: 0,
        rows: 10,
        page: 0,
        filters: {
            idNumber: { value: null, matchMode: "contains" },
            socialInsuranceCode: { value: null, matchMode: "contains" },
            docType: { value: bhxh, matchMode: "equals" },
        },
    });

    const [dataSearchbhyt, setDataSearchbhyt] = useState({
        first: 0,
        rows: 10,
        page: 0,
        filters: {
            idNumber: { value: null, matchMode: "contains" },
            healthInsuranceCode: { value: null, matchMode: "contains" },
            docType: { value: bhyt, matchMode: "equals" },
        },
    });

    const [dataSearchdkyxe, setDataSearchdkyxe] = useState({
        first: 0,
        rows: 10,
        page: 0,
        filters: {
            idNumber: { value: null, matchMode: "contains" },
            documentCodeRegis: { value: null, matchMode: "contains" },
            docType: { value: dkyxe, matchMode: "equals" },
        },
    });

    const [dataSearchgplx, setDataSearchgplx] = useState({
        first: 0,
        rows: 10,
        page: 0,
        filters: {
            idNumber: { value: null, matchMode: "contains" },
            documentCodeDrive: { value: null, matchMode: "contains" },
            docType: { value: gplx, matchMode: "equals" },
        },
    });

    const [dataSearchmst, setDataSearchmstx] = useState({
        first: 0,
        rows: 10,
        page: 0,
        filters: {
            idNumber: { value: null, matchMode: "contains" },
            taxCode: { value: null, matchMode: "contains" },
            docType: { value: mst, matchMode: "equals" },
        },
    });

    useEffect(() => {
        if (checkLoadbhxh) {
            loadLazyDataBhxh();
            setCheckLoadbhxh(false);
        }
    }, [dataSearchbhxh]);

    const loadLazyDataBhxh = () => {
        setApprovalResultbhxhs([]);
        setApprovalResultbhxh(null);
        findApprovalResultByDocType(headers, dataSearchbhxh)
            .then((res) => {
                setTotalRecordbhxhs(res.headers[X_TOTAL_COUNT] ? parseInt(res.headers[X_TOTAL_COUNT]) : 0);
                const dataRes = res.data;
                dataRes?.forEach((e, i) => {
                    e.stt = dataSearchbhxh.rows * dataSearchbhxh.page + 1 + i;
                });
                if (dataRes.length > 0) {
                    setApprovalResultbhxh(dataRes[0]);
                }
                setApprovalResultbhxhs(dataRes);
            })
            .catch((error) => handleError(toast, t, error));
    };

    useEffect(() => {
        if (checkLoadbhyt) {
            loadLazyDataBhyt();
            setCheckLoadbhyt(false);
        }
    }, [dataSearchbhyt]);

    const loadLazyDataBhyt = () => {
        setApprovalResultbhyts([]);
        setApprovalResultbhyt(null);
        findApprovalResultByDocType(headers, dataSearchbhyt)
            .then((res) => {
                setTotalRecordbhyts(res.headers[X_TOTAL_COUNT] ? parseInt(res.headers[X_TOTAL_COUNT]) : 0);
                const dataRes = res.data;
                dataRes?.forEach((e, i) => {
                    e.stt = dataSearchbhyt.rows * dataSearchbhyt.page + 1 + i;
                });
                if (dataRes.length > 0) {
                    setApprovalResultbhyt(dataRes[0]);
                }
                setApprovalResultbhyts(dataRes);
            })
            .catch((error) => handleError(toast, t, error));
    };

    useEffect(() => {
        if (checkLoaddkyxe) {
            loadLazyDataDkyxe();
            setCheckLoaddkxe(false);
        }
    }, [dataSearchdkyxe]);

    const loadLazyDataDkyxe = () => {
        setApprovalResultdkyxes([]);
        setApprovalResultdkyxe(null);
        findApprovalResultByDocType(headers, dataSearchdkyxe)
            .then((res) => {
                setTotalRecorddkyxes(res.headers[X_TOTAL_COUNT] ? parseInt(res.headers[X_TOTAL_COUNT]) : 0);
                const dataRes = res.data;
                dataRes?.forEach((e, i) => {
                    e.stt = dataSearchdkyxe.rows * dataSearchdkyxe.page + 1 + i;
                });
                if (dataRes.length > 0) {
                    setApprovalResultdkyxe(dataRes[0]);
                }
                setApprovalResultdkyxes(dataRes);
            })
            .catch((error) => handleError(toast, t, error));
    };

    useEffect(() => {
        if (checkLoadgplx) {
            loadLazyDataGplx();
            setCheckLoadgplx(false);
        }
    }, [dataSearchgplx]);

    const loadLazyDataGplx = () => {
        setApprovalResultgplxs([]);
        setApprovalResultgplx(null);
        findApprovalResultByDocType(headers, dataSearchgplx)
            .then((res) => {
                setTotalRecordgplxs(res.headers[X_TOTAL_COUNT] ? parseInt(res.headers[X_TOTAL_COUNT]) : 0);
                const dataRes = res.data;
                dataRes?.forEach((e, i) => {
                    e.stt = dataSearchgplx.rows * dataSearchgplx.page + 1 + i;
                });
                if (dataRes.length > 0) {
                    setApprovalResultgplx(dataRes[0]);
                }
                setApprovalResultgplxs(dataRes);
            })
            .catch((error) => handleError(toast, t, error));
    };

    useEffect(() => {
        if (checkLoadthuecn) {
            loadLazyDataMstx();
            setCheckLoadthuecn(false);
        }
    }, [dataSearchmst]);

    const loadLazyDataMstx = () => {
        setApprovalResultmsts([]);
        setApprovalResultmst(null);
        findApprovalResultByDocType(headers, dataSearchmst)
            .then((res) => {
                setTotalRecordthuecns(res.headers[X_TOTAL_COUNT] ? parseInt(res.headers[X_TOTAL_COUNT]) : 0);
                const dataRes = res.data;
                dataRes?.forEach((e, i) => {
                    e.stt = dataSearchmst.rows * dataSearchmst.page + 1 + i;
                });
                if (dataRes.length > 0) {
                    setApprovalResultmst(dataRes[0]);
                }
                setApprovalResultmsts(dataRes);
            })
            .catch((error) => handleError(toast, t, error));
    };

    const onPagebhxh = (event) => {
        setCheckLoadbhxh(true);
        let _lazyParams = { ...dataSearchbhxh, ...event };
        setDataSearchbhxh(_lazyParams);
    };

    const onSortbhxh = (event) => {
        setCheckLoadbhxh(true);
        let _lazyParams = { ...dataSearchbhxh, ...event };
        setDataSearchbhxh(_lazyParams);
    };

    const onFilterbhxh = (event) => {
        setCheckLoadbhxh(true);
        let _lazyParams = { ...dataSearchbhxh, ...event };
        _lazyParams["first"] = 0;
        setDataSearchbhxh(_lazyParams);
    };

    const onPagebhyt = (event) => {
        setCheckLoadbhyt(true);
        let _lazyParams = { ...dataSearchbhyt, ...event };
        setDataSearchbhyt(_lazyParams);
    };

    const onSortbhyt = (event) => {
        setCheckLoadbhyt(true);
        let _lazyParams = { ...dataSearchbhyt, ...event };
        setDataSearchbhyt(_lazyParams);
    };

    const onFilterbhyt = (event) => {
        setCheckLoadbhyt(true);
        let _lazyParams = { ...dataSearchbhyt, ...event };
        _lazyParams["first"] = 0;
        setDataSearchbhyt(_lazyParams);
    };

    const onPagedkyxe = (event) => {
        setCheckLoaddkxe(true);
        let _lazyParams = { ...dataSearchdkyxe, ...event };
        setDataSearchdkyxe(_lazyParams);
    };

    const onSortdkyxe = (event) => {
        setCheckLoaddkxe(true);
        let _lazyParams = { ...dataSearchdkyxe, ...event };
        setDataSearchdkyxe(_lazyParams);
    };

    const onFilterdkyxe = (event) => {
        setCheckLoaddkxe(true);
        let _lazyParams = { ...dataSearchdkyxe, ...event };
        _lazyParams["first"] = 0;
        setDataSearchdkyxe(_lazyParams);
    };

    const onPagegplx = (event) => {
        setCheckLoadgplx(true);
        let _lazyParams = { ...dataSearchgplx, ...event };
        setDataSearchgplx(_lazyParams);
    };

    const onSortgplx = (event) => {
        setCheckLoadgplx(true);
        let _lazyParams = { ...dataSearchgplx, ...event };
        setDataSearchgplx(_lazyParams);
    };

    const onFiltergplx = (event) => {
        setCheckLoadgplx(true);
        let _lazyParams = { ...dataSearchgplx, ...event };
        _lazyParams["first"] = 0;
        setDataSearchgplx(_lazyParams);
    };

    const onPagethuecn = (event) => {
        setCheckLoadthuecn(true);
        let _lazyParams = { ...dataSearchmst, ...event };
        setDataSearchmstx(_lazyParams);
    };

    const onSortthuecn = (event) => {
        setCheckLoadthuecn(true);
        let _lazyParams = { ...dataSearchmst, ...event };
        setDataSearchmstx(_lazyParams);
    };

    const onFilterthuecn = (event) => {
        setCheckLoadthuecn(true);
        let _lazyParams = { ...dataSearchmst, ...event };
        _lazyParams["first"] = 0;
        setDataSearchmstx(_lazyParams);
    };

    const paginatorTemplate = {
        layout: "RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
        RowsPerPageDropdown: (options) => {
            const dropdownOptions = [
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 30, value: 30 },
                { label: 50, value: 50 },
            ];

            return (
                <React.Fragment>
                    <div style={{ width: "140px", display: "inline-block" }}>
                        <span className="mx-1">{t("show", { ns: "common" })}: </span>
                        <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                    </div>
                </React.Fragment>
            );
        },
        CurrentPageReport: (options) => {
            return <span style={{ width: "calc(100% - 490px)", textAlign: "center", display: "inline-block" }}>{t("total", { ns: "common", total: options.totalRecords })}</span>;
        },
    };

    const searchOptionbhxh = (
        <div className="grid">
            {/* số ĐDCN */}
            <div className="col-12 md:col-4">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "130px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="idNumber"
                    >
                        {t("approval-result.idNumber")}
                    </label>
                    <div className="col">
                        <InputText
                            style={{
                                width: "100%",
                            }}
                            id="idNumber"
                            name="idNumber"
                            value={dataSearchbhxh.filters.idNumber.value}
                            onChange={(e) => {
                                setCheckLoadbhxh(false);
                                setDataSearchbhxh({
                                    ...dataSearchbhxh,
                                    filters: {
                                        ...dataSearchbhxh.filters,
                                        idNumber: {
                                            ...dataSearchbhxh.filters.idNumber,
                                            value: e.target.value,
                                        },
                                    },
                                });
                            }}
                        ></InputText>
                        {/* {submitbhxh && !dataSearchbhxh.filters.idNumber.value && <small className="text-danger">{t("approval-result.idNumberrequest")}</small>} */}
                    </div>
                </div>
            </div>

            {/* mã số bảo hiểm xã hội */}
            <div className="col-12 md:col-4">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "130px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="socialInsuranceCode"
                    >
                        {t("approval-result.socialInsuranceCode")}
                    </label>
                    <div className="col">
                        <InputText
                            style={{
                                width: "100%",
                            }}
                            id="socialInsuranceCode"
                            name="socialInsuranceCode"
                            value={dataSearchbhxh.filters.socialInsuranceCode.value}
                            onChange={(e) => {
                                setCheckLoadbhxh(false);
                                setDataSearchbhxh({
                                    ...dataSearchbhxh,
                                    filters: {
                                        ...dataSearchbhxh.filters,
                                        socialInsuranceCode: {
                                            ...dataSearchbhxh.filters.socialInsuranceCode,
                                            value: e.target.value,
                                        },
                                    },
                                });
                            }}
                        ></InputText>
                        {/* {submitbhxh && !dataSearchbhxh.filters.socialInsuranceCode.value && <small className="text-danger">{t("approval-result.socialInsuranceCoderequest")}</small>} */}
                    </div>
                </div>
            </div>

            <div className="col-12 md:col-4 text-right">
                <div className="grid custom-form">
                    <div className="col-12">
                        <label
                            style={{
                                // width: "130px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                        >
                            {" "}
                        </label>
                    </div>
                    <div className="col-12" style={{ margin: "5px 0px 0px 0px" }}>
                        <Button
                            label={t("search", { ns: "common" })}
                            icon="pi pi-search"
                            onClick={(e) => {
                                setSubmitbhxh(true);
                                setCheckLoadbhxh(true);
                                if (dataSearchbhxh.filters.idNumber.value || dataSearchbhxh.filters.socialInsuranceCode.value) {
                                    setDataSearchbhxh({
                                        ...dataSearchbhxh,
                                        first: 0,
                                        page: 0,
                                    });
                                } else {
                                    toast.current.show({ severity: "info", summary: t("info", { ns: "common" }), detail: t("approval-result.requireidNumberOrsocialInsuranceCode"), life: 3000 });
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );

    const searchOptionbhyt = (
        <div className="grid">
            {/* số ĐDCN */}
            <div className="col-12 md:col-4">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "130px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="idNumber"
                    >
                        {t("approval-result.idNumber")}
                    </label>
                    <div className="col">
                        <InputText
                            style={{
                                width: "100%",
                            }}
                            id="idNumber"
                            name="idNumber"
                            value={dataSearchbhyt.filters.idNumber.value}
                            onChange={(e) => {
                                setCheckLoadbhyt(false);
                                setDataSearchbhyt({
                                    ...dataSearchbhyt,
                                    filters: {
                                        ...dataSearchbhyt.filters,
                                        idNumber: {
                                            ...dataSearchbhyt.filters.idNumber,
                                            value: e.target.value,
                                        },
                                    },
                                });
                            }}
                        ></InputText>
                        {/* {submitbhyt && !dataSearchbhyt.filters.idNumber.value && <small className="text-danger">{t("approval-result.idNumberrequest")}</small>} */}
                    </div>
                </div>
            </div>

            {/* mã số bhyt */}
            <div className="col-12 md:col-4">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "130px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="healthInsuranceCode"
                    >
                        {t("approval-result.healthInsuranceCode")}
                    </label>
                    <div className="col">
                        <InputText
                            style={{
                                width: "100%",
                            }}
                            id="healthInsuranceCode"
                            name="healthInsuranceCode"
                            value={dataSearchbhyt.filters.healthInsuranceCode.value}
                            onChange={(e) => {
                                setCheckLoadbhyt(false);
                                setDataSearchbhyt({
                                    ...dataSearchbhyt,
                                    filters: {
                                        ...dataSearchbhyt.filters,
                                        healthInsuranceCode: {
                                            ...dataSearchbhyt.filters.healthInsuranceCode,
                                            value: e.target.value,
                                        },
                                    },
                                });
                            }}
                        ></InputText>
                        {/* {submitbhyt && !dataSearchbhyt.filters.healthInsuranceCode.value && <small className="text-danger">{t("approval-result.healthInsuranceCoderequest")}</small>} */}
                    </div>
                </div>
            </div>

            <div className="col-12 md:col-4 text-right">
                <div className="grid custom-form">
                    <div className="col-12">
                        <label
                            style={{
                                // width: "130px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                        >
                            {" "}
                        </label>
                    </div>
                    <div className="col-12" style={{ margin: "5px 0px 0px 0px" }}>
                        <Button
                            label={t("search", { ns: "common" })}
                            icon="pi pi-search"
                            onClick={(e) => {
                                setSubmitbhyt(true);
                                setCheckLoadbhyt(true);
                                if (dataSearchbhyt.filters.idNumber.value || dataSearchbhyt.filters.healthInsuranceCode.value) {
                                    setDataSearchbhyt({
                                        ...dataSearchbhyt,
                                        first: 0,
                                        page: 0,
                                    });
                                } else {
                                    toast.current.show({ severity: "info", summary: t("info", { ns: "common" }), detail: t("approval-result.requireidNumberOrhealthInsuranceCode"), life: 3000 });
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );

    const searchOptiondkyxe = (
        <div className="grid">
            {/* số ĐDCN */}
            <div className="col-12 md:col-4">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "130px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="idNumber"
                    >
                        {t("approval-result.idNumber")}
                    </label>
                    <div className="col">
                        <InputText
                            style={{
                                width: "100%",
                            }}
                            id="idNumber"
                            name="idNumber"
                            value={dataSearchdkyxe.filters.idNumber.value}
                            onChange={(e) => {
                                setCheckLoaddkxe(false);
                                setDataSearchdkyxe({
                                    ...dataSearchdkyxe,
                                    filters: {
                                        ...dataSearchdkyxe.filters,
                                        idNumber: {
                                            ...dataSearchdkyxe.filters.idNumber,
                                            value: e.target.value,
                                        },
                                    },
                                });
                            }}
                        ></InputText>
                        {/* {submitdkyxe && !dataSearchdkyxe.filters.idNumber.value && <small className="text-danger">{t("approval-result.idNumberrequest")}</small>} */}
                    </div>
                </div>
            </div>

            {/* số chứng nhận ĐK xe */}
            <div className="col-12 md:col-4">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "210px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="documentCodeRegis"
                    >
                        {t("approval-result.documentCodeRegis")}
                    </label>
                    <div className="col">
                        <InputText
                            style={{
                                width: "100%",
                            }}
                            value={dataSearchdkyxe.filters.documentCodeRegis.value}
                            id="documentCodeRegis"
                            name="documentCodeRegis"
                            onChange={(e) => {
                                setCheckLoaddkxe(false);
                                setDataSearchdkyxe({
                                    ...dataSearchdkyxe,
                                    filters: {
                                        ...dataSearchdkyxe.filters,
                                        documentCodeRegis: {
                                            ...dataSearchdkyxe.filters.documentCodeRegis,
                                            value: e.target.value,
                                        },
                                    },
                                });
                            }}
                        ></InputText>
                        {/* {submitdkyxe && !dataSearchdkyxe.filters.documentCodeRegis.value && <small className="text-danger">{t("approval-result.documentCodeRegisrequest")}</small>} */}
                    </div>
                </div>
            </div>

            <div className="col-12 md:col-4 text-right">
                <div className="grid custom-form">
                    <div className="col-12">
                        <label
                            style={{
                                // width: "130px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                        >
                            {" "}
                        </label>
                    </div>
                    <div className="col-12" style={{ margin: "5px 0px 0px 0px" }}>
                        <Button
                            label={t("search", { ns: "common" })}
                            icon="pi pi-search"
                            onClick={(e) => {
                                setSubmitdkxe(true);
                                setCheckLoaddkxe(true);
                                if (dataSearchdkyxe.filters.idNumber.value || dataSearchdkyxe.filters.documentCodeRegis.value) {
                                    setDataSearchdkyxe({
                                        ...dataSearchdkyxe,
                                        first: 0,
                                        page: 0,
                                    });
                                } else {
                                    toast.current.show({ severity: "info", summary: t("info", { ns: "common" }), detail: t("approval-result.requireidNumberOrdocumentCodeRegis"), life: 3000 });
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );

    const searchOptiongplx = (
        <div className="grid">
            {/* số ĐDCN */}
            <div className="col-12 md:col-4">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "130px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="idNumber"
                    >
                        {t("approval-result.idNumber")}
                    </label>
                    <div className="col">
                        <InputText
                            style={{
                                width: "100%",
                            }}
                            id="idNumber"
                            name="idNumber"
                            value={dataSearchgplx.filters.idNumber.value}
                            onChange={(e) => {
                                setCheckLoadgplx(false);
                                setDataSearchgplx({
                                    ...dataSearchgplx,
                                    filters: {
                                        ...dataSearchgplx.filters,
                                        idNumber: {
                                            ...dataSearchgplx.filters.idNumber,
                                            value: e.target.value,
                                        },
                                    },
                                });
                            }}
                        ></InputText>
                        {/* {submitgplx && !dataSearchgplx.filters.idNumber.value && <small className="text-danger">{t("approval-result.idNumberrequest")}</small>} */}
                    </div>
                </div>
            </div>

            {/* số gplx */}
            <div className="col-12 md:col-4">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "130px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="documentCodeDrive"
                    >
                        {t("approval-result.documentCodeDrive")}
                    </label>
                    <div className="col">
                        <InputText
                            style={{
                                width: "100%",
                            }}
                            id="documentCodeDrive"
                            name="documentCodeDrive"
                            value={dataSearchgplx.filters.documentCodeDrive.value}
                            onChange={(e) => {
                                setCheckLoadgplx(false);
                                setDataSearchgplx({
                                    ...dataSearchgplx,
                                    filters: {
                                        ...dataSearchgplx.filters,
                                        documentCodeDrive: {
                                            ...dataSearchgplx.filters.documentCodeDrive,
                                            value: e.target.value,
                                        },
                                    },
                                });
                            }}
                        ></InputText>
                        {/* {submitgplx && !dataSearchgplx.filters.documentCodeDrive.value && <small className="text-danger">{t("approval-result.documentCodeDriverequest")}</small>} */}
                    </div>
                </div>
            </div>

            <div className="col-12 md:col-4 text-right">
                <div className="grid custom-form">
                    <div className="col-12">
                        <label
                            style={{
                                // width: "130px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                        >
                            {" "}
                        </label>
                    </div>
                    <div className="col-12" style={{ margin: "5px 0px 0px 0px" }}>
                        <Button
                            label={t("search", { ns: "common" })}
                            icon="pi pi-search"
                            onClick={(e) => {
                                setSubmitgplx(true);
                                setCheckLoadgplx(true);
                                if (dataSearchgplx.filters.idNumber.value || dataSearchgplx.filters.documentCodeDrive.value) {
                                    setDataSearchgplx({
                                        ...dataSearchgplx,
                                        first: 0,
                                        page: 0,
                                    });
                                } else {
                                    toast.current.show({ severity: "info", summary: t("info", { ns: "common" }), detail: t("approval-result.requireidNumberOrdocumentCodeDrive"), life: 3000 });
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );

    const searchOptionthuecn = (
        <div className="grid">
            {/* số ĐDCN */}
            <div className="col-12 md:col-4">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "130px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="idNumber"
                    >
                        {t("approval-result.idNumber")}
                    </label>
                    <div className="col">
                        <InputText
                            style={{
                                width: "100%",
                            }}
                            id="idNumber"
                            name="idNumber"
                            value={dataSearchmst.filters.idNumber.value}
                            onChange={(e) => {
                                setCheckLoadthuecn(false);
                                setDataSearchmstx({
                                    ...dataSearchmst,
                                    filters: {
                                        ...dataSearchmst.filters,
                                        idNumber: {
                                            ...dataSearchmst.idNumber,
                                            value: e.target.value,
                                        },
                                    },
                                });
                            }}
                        ></InputText>
                        {/* {submitthuecn && !dataSearchmst.filters.idNumber.value && <small className="text-danger">{t("approval-result.idNumberrequest")}</small>} */}
                    </div>
                </div>
            </div>

            {/* mã số thuế */}
            <div className="col-12 md:col-4">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "130px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="taxCode"
                    >
                        {t("approval-result.taxCode")}
                    </label>
                    <div className="col">
                        <InputText
                            style={{
                                width: "100%",
                            }}
                            id="taxCode"
                            name="taxCode"
                            value={dataSearchmst.filters.taxCode.value}
                            onChange={(e) => {
                                setCheckLoadthuecn(false);
                                setDataSearchmstx({
                                    ...dataSearchmst,
                                    filters: {
                                        ...dataSearchmst.filters,
                                        taxCode: {
                                            ...dataSearchmst.taxCode,
                                            value: e.target.value,
                                        },
                                    },
                                });
                            }}
                        ></InputText>
                        {/* {submitthuecn && !dataSearchmst.filters.taxCode.value && <small className="text-danger">{t("approval-result.taxCoderequest")}</small>} */}
                    </div>
                </div>
            </div>

            <div className="col-12 md:col-4 text-right">
                <div className="grid custom-form">
                    <div className="col-12">
                        <label
                            style={{
                                // width: "130px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                        >
                            {" "}
                        </label>
                    </div>
                    <div className="col-12" style={{ margin: "5px 0px 0px 0px" }}>
                        <Button
                            label={t("search", { ns: "common" })}
                            icon="pi pi-search"
                            onClick={(e) => {
                                setSubmitthuecn(true);
                                setCheckLoadthuecn(true);
                                if (dataSearchmst.filters.idNumber.value || dataSearchmst.filters.taxCode.value) {
                                    setDataSearchmstx({
                                        ...dataSearchmst,
                                        first: 0,
                                        page: 0,
                                    });
                                } else {
                                    toast.current.show({ severity: "info", summary: t("info", { ns: "common" }), detail: t("approval-result.requireidNumberOrtaxCode"), life: 3000 });
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );

    const enabledBodyTemplate = (rowData) => {
        return <div className="flex align-items-center justify-content-center actions">{trangThais.find((e) => e.value === rowData.scanStatus)?.label}</div>;
    };

    const templateApprovalResult = (rowData) => {
        return <div className="flex align-items-center justify-content-center actions">{approvalResultses.find((e) => e.value === rowData.approvalResults)?.label}</div>;
    };

    const checkboxBodyTemplate = (rowData) => {
        return (
            <>
                <div className="flex align-items-center justify-content-center">
                    <Checkbox checked={rowData.enabled === "Y"} readOnly />
                </div>
            </>
        );
    };

    return (
        <div className="grid crud">
            <div className="col-12">
                <div className="card">
                    <div className="grid">
                        <div className="col-12">
                            <h4 className="text-center font-bold">{t("approval-result.title")?.toUpperCase()}</h4>
                        </div>
                    </div>
                    <Toast ref={toast} />
                    <div className="grid">
                        <div className="col-12">
                            <TabView>
                                <TabPanel header={t("approval-result.bhxh")}>
                                    <div className="grid">
                                        <div className="col-12">
                                            <BlockDetail title={t("search", { ns: "common" })}>{searchOptionbhxh}</BlockDetail>
                                        </div>
                                    </div>
                                    <div className="grid">
                                        <div className="col-12">
                                            <div className="col-12">
                                                <BlockDetail title={t("approval-result.listbhxh")}>
                                                    <DataTable
                                                        ref={dt}
                                                        value={approvalResultbhxhs}
                                                        dataKey="stt"
                                                        className="datatable-responsive p-datatable-sm"
                                                        showGridlines
                                                        lazy
                                                        paginator
                                                        selectionMode="single"
                                                        selection={approvalResultbhxh}
                                                        onSelectionChange={(e) => {
                                                            setApprovalResultbhxh(e.value);
                                                        }}
                                                        rows={dataSearchbhxh.rows}
                                                        first={dataSearchbhxh.first}
                                                        totalRecords={totalRecordbhxhs}
                                                        onPage={onPagebhxh}
                                                        onSort={onSortbhxh}
                                                        sortField={dataSearchbhxh.sortField}
                                                        sortOrder={dataSearchbhxh.sortOrder}
                                                        onFilter={onFilterbhxh}
                                                        filters={dataSearchbhxh.filters}
                                                        paginatorClassName="justify-content-start"
                                                        paginatorTemplate={paginatorTemplate}
                                                        emptyMessage="Không có dữ liệu"
                                                        scrollable
                                                    >
                                                        <Column field="stt" header={t("stt", { ns: "common" })} style={{ maxWidth: "50px" }} />
                                                        <Column field="idNumber" header={t("approval-result.idNumber")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                        <Column field="socialInsuranceCode" header={t("approval-result.socialInsuranceCode")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                        <Column field="enabled" header={t("approval-result.enabled")} body={checkboxBodyTemplate} style={{ minWidth: "100px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                        <Column field="startDate" header={t("approval-result.startDate")} />

                                                        <Column field="approvalResults" header={t("approval-result.approvalResults")} body={templateApprovalResult} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />

                                                        <Column field="approvalDate" header={t("approval-result.approvalDate")} style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    </DataTable>
                                                </BlockDetail>
                                            </div>
                                        </div>
                                    </div>
                                    {approvalResultbhxh && (
                                        <div className="grid">
                                            <div className="col-12">
                                                <BlockDetail title={t("approval-result.infobhxh")}>
                                                    <div className="grid">
                                                        {/* Công ty, đơn vị */}
                                                        <div className="field col-12 md:col-6">
                                                            <label htmlFor="unitName" className="custom-form">
                                                                {t("approval-result.unitName")}
                                                            </label>
                                                            <InputText id="unitName" value={approvalResultbhxh?.unitName} readOnly className="custom-form" tooltip={approvalResultbhxh.unitName} tooltipOptions={{ position: "top" }} />
                                                        </div>

                                                        {/* nghe nghiep */}
                                                        <div className="field col-12 md:col-2">
                                                            <label htmlFor="career" className="custom-form">
                                                                {t("approval-result.career")}
                                                            </label>
                                                            <InputText id="career" value={approvalResultbhxh?.career} readOnly className="custom-form" />
                                                        </div>

                                                        {/*  ngay nhan ket qua */}
                                                        <div className="field col-12 md:col-2">
                                                            <label htmlFor="receiveDate" className="custom-form">
                                                                {t("approval-result.receiveDate")}
                                                            </label>
                                                            <InputText id="receiveDate" value={approvalResultbhxh?.createdDate} readOnly className="custom-form" />
                                                        </div>

                                                        {/* id hồ sơ */}
                                                        <div className="field col-12 md:col-2">
                                                            <label htmlFor="fileId" className="custom-form">
                                                                {t("approval-result.fileId")}
                                                            </label>
                                                            <InputText id="fileId" value={approvalResultbhxh?.fileId} readOnly className="custom-form" />
                                                        </div>
                                                    </div>

                                                    <div className="grid">
                                                        {/* lý do không đạt */}
                                                        <div className="field col-12 md:col-6">
                                                            <label htmlFor="reasonNotPass" className="custom-form">
                                                                {t("approval-result.reasonNotPass")}
                                                            </label>
                                                            <InputText id="reasonNotPass" value={approvalResultbhxh?.reasonNotPassContent} readOnly className="custom-form" tooltip={approvalResultbhxh.reasonNotPassContent} tooltipOptions={{ position: "top" }} />
                                                        </div>

                                                        {/* mo ta ly do */}
                                                        <div className="field col-12 md:col-6">
                                                            <label htmlFor="descriptionReason" className="custom-form">
                                                                {t("approval-result.descriptionReason")}
                                                            </label>
                                                            <InputText id="descriptionReason" value={approvalResultbhxh?.descriptionReason} readOnly className="custom-form" tooltip={approvalResultbhxh.descriptionReason} tooltipOptions={{ position: "top" }} />
                                                        </div>
                                                    </div>
                                                </BlockDetail>
                                            </div>
                                        </div>
                                    )}
                                </TabPanel>
                                <TabPanel header={t("approval-result.bhyt")}>
                                    <div className="grid">
                                        <div className="col-12">
                                            <BlockDetail title={t("search", { ns: "common" })}>{searchOptionbhyt}</BlockDetail>
                                        </div>
                                    </div>

                                    <div className="grid">
                                        <div className="col-12">
                                            <BlockDetail title={t("approval-result.listbhyt")}>
                                                <DataTable
                                                    ref={dt}
                                                    value={approvalResultbhyts}
                                                    dataKey="stt"
                                                    className="datatable-responsive p-datatable-sm"
                                                    showGridlines
                                                    selectionMode="single"
                                                    selection={approvalResultbhyt}
                                                    onSelectionChange={(e) => {
                                                        setApprovalResultbhyt(e.value);
                                                    }}
                                                    lazy
                                                    paginator
                                                    rows={dataSearchbhyt.rows}
                                                    first={dataSearchbhyt.first}
                                                    totalRecords={totalRecordbhyts}
                                                    onPage={onPagebhyt}
                                                    onSort={onSortbhyt}
                                                    sortField={dataSearchbhyt.sortField}
                                                    sortOrder={dataSearchbhyt.sortOrder}
                                                    onFilter={onFilterbhyt}
                                                    filters={dataSearchbhyt.filters}
                                                    paginatorClassName="justify-content-start"
                                                    paginatorTemplate={paginatorTemplate}
                                                    emptyMessage="Không có dữ liệu"
                                                    scrollable
                                                >
                                                    <Column field="stt" header={t("stt", { ns: "common" })} style={{ maxWidth: "50px" }} />
                                                    <Column field="idNumber" header={t("approval-result.idNumber")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="healthInsuranceCode" header={t("approval-result.healthInsuranceCode")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="enabled" header={t("approval-result.enabled")} body={checkboxBodyTemplate} style={{ minWidth: "100px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="issuedOn" header={t("approval-result.issuedOn")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="approvalResults" header={t("approval-result.approvalResults")} body={templateApprovalResult} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="approvalDate" header={t("approval-result.approvalDate")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                </DataTable>
                                            </BlockDetail>
                                        </div>
                                    </div>

                                    {approvalResultbhyt && (
                                        <BlockDetail title={t("approval-result.infobhyt")}>
                                            <div className="grid">
                                                <div className="col-12">
                                                    <div className="grid">
                                                        {/* ho và ten */}
                                                        <div className="field col-12 md:col-3">
                                                            <label htmlFor="fullName" className="custom-form">
                                                                {t("approval-result.fullName")}
                                                            </label>
                                                            <InputText id="fullName" value={approvalResultbhyt?.fullName} readOnly className="custom-form" />
                                                        </div>

                                                        {/* ngay sinh */}
                                                        <div className="field col-12 md:col-2">
                                                            <label htmlFor="birthDate" className="custom-form">
                                                                {t("approval-result.birthDate")}
                                                            </label>
                                                            <InputText id="birthDate" value={approvalResultbhyt?.birthDate} readOnly className="custom-form" />
                                                        </div>

                                                        {/* gioi tinh */}
                                                        <div className="field col-12 md:col-2">
                                                            <label htmlFor="gender" className="custom-form">
                                                                {t("approval-result.gender")}
                                                            </label>
                                                            <InputText id="gender" value={approvalResultbhyt?.gender} readOnly className="custom-form" />
                                                        </div>

                                                        {/* nơi đăng ký KCB ban đầu */}
                                                        <div className="field col-12 md:col-3">
                                                            <label htmlFor="healthcare" className="custom-form">
                                                                {t("approval-result.healthcare")}
                                                            </label>
                                                            <InputText id="healthcare" value={approvalResultbhyt?.healthcare} readOnly className="custom-form" tooltip={approvalResultbhyt.healthcare} tooltipOptions={{ position: "top" }} />
                                                        </div>

                                                        {/* mức hưởng BHYT */}
                                                        <div className="field col-12 md:col-2">
                                                            <label htmlFor="benefitRate" className="custom-form">
                                                                {t("approval-result.benefitRate")}
                                                            </label>
                                                            <InputText id="benefitRate" value={approvalResultbhyt?.benefitRate} readOnly className="custom-form" />
                                                        </div>
                                                    </div>

                                                    <div className="grid">
                                                        {/* ngay hieu lục tu */}
                                                        <div className="field col-12 md:col-2">
                                                            <label htmlFor="startDate" className="custom-form">
                                                                {t("approval-result.startDate1")}
                                                            </label>
                                                            <InputText id="startDate" value={approvalResultbhyt?.startDate} readOnly className="custom-form" />
                                                        </div>

                                                        {/* hieu luc den */}
                                                        <div className="field col-12 md:col-2">
                                                            <label htmlFor="expirationDate" className="custom-form">
                                                                {t("approval-result.expirationDate")}
                                                            </label>
                                                            <InputText id="expirationDate" value={approvalResultbhyt?.expirationDate} readOnly className="custom-form" />
                                                        </div>

                                                        {/* noi cap doi the */}
                                                        <div className="field col-12 md:col-4">
                                                            <label htmlFor="exchagePlace" className="custom-form">
                                                                {t("approval-result.exchagePlace")}
                                                            </label>
                                                            <InputText id="exchagePlace" value={approvalResultbhyt?.exchagePlace} readOnly className="custom-form" tooltip={approvalResultbhyt.exchagePlace} tooltipOptions={{ position: "top" }} />
                                                        </div>

                                                        {/* ngay nhan kq */}
                                                        <div className="field col-12 md:col-2">
                                                            <label htmlFor="receiveDate" className="custom-form">
                                                                {t("approval-result.receiveDate")}
                                                            </label>
                                                            <InputText id="receiveDate" value={approvalResultbhyt?.createdDate} readOnly className="custom-form" />
                                                        </div>

                                                        {/* id ho so */}
                                                        <div className="field col-12 md:col-2">
                                                            <label htmlFor="fileId" className="custom-form">
                                                                {t("approval-result.fileId")}
                                                            </label>
                                                            <InputText id="fileId" value={approvalResultbhyt?.fileId} readOnly className="custom-form" />
                                                        </div>
                                                    </div>

                                                    <div className="grid">
                                                        {/* lý do khong dat */}
                                                        <div className="field col-12 md:col-6">
                                                            <label htmlFor="reasonNotPass" className="custom-form">
                                                                {t("approval-result.reasonNotPass")}
                                                            </label>
                                                            <InputText id="reasonNotPass" value={approvalResultbhyt?.reasonNotPassContent} readOnly className="custom-form" tooltip={approvalResultbhyt.reasonNotPassContent} tooltipOptions={{ position: "top" }} />
                                                        </div>

                                                        {/* mô tả lý do */}
                                                        <div className="field col-12 md:col-6">
                                                            <label htmlFor="descriptionReason" className="custom-form">
                                                                {t("approval-result.descriptionReason")}
                                                            </label>
                                                            <InputText id="descriptionReason" value={approvalResultbhyt?.descriptionReason} readOnly className="custom-form" tooltip={approvalResultbhyt.descriptionReason} tooltipOptions={{ position: "top" }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </BlockDetail>
                                    )}
                                </TabPanel>
                                <TabPanel header={t("approval-result.dkyxe")}>
                                    <div className="grid">
                                        <div className="col-12">
                                            <BlockDetail title={t("search", { ns: "common" })}>{searchOptiondkyxe}</BlockDetail>
                                        </div>
                                    </div>

                                    <div className="grid">
                                        <div className="col-12">
                                            <BlockDetail title={t("approval-result.listdkyxe")}>
                                                <DataTable
                                                    ref={dt}
                                                    value={approvalResultdkyxes}
                                                    dataKey="stt"
                                                    className="datatable-responsive p-datatable-sm"
                                                    showGridlines
                                                    lazy
                                                    paginator
                                                    selectionMode="single"
                                                    selection={approvalResultdkyxe}
                                                    onSelectionChange={(e) => {
                                                        setApprovalResultdkyxe(e.value);
                                                    }}
                                                    rows={dataSearchdkyxe.rows}
                                                    first={dataSearchdkyxe.first}
                                                    totalRecords={totalRecorddkyxes}
                                                    onPage={onPagedkyxe}
                                                    onSort={onSortdkyxe}
                                                    sortField={dataSearchdkyxe.sortField}
                                                    sortOrder={dataSearchdkyxe.sortOrder}
                                                    onFilter={onFilterdkyxe}
                                                    filters={dataSearchdkyxe.filters}
                                                    paginatorClassName="justify-content-start"
                                                    paginatorTemplate={paginatorTemplate}
                                                    emptyMessage="Không có dữ liệu"
                                                    scrollable
                                                >
                                                    <Column field="stt" header={t("stt", { ns: "common" })} style={{ maxWidth: "50px" }} />
                                                    <Column field="idNumber" header={t("approval-result.idNumber")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="documentCode" header={t("approval-result.documentCode")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="enabled" header={t("approval-result.enabled")} body={checkboxBodyTemplate} style={{ minWidth: "100px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="issuedOn" header={t("approval-result.issuedOn")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="approvalResults" header={t("approval-result.approvalResults")} body={templateApprovalResult} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="approvalDate" header={t("approval-result.approvalDate")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                </DataTable>
                                            </BlockDetail>
                                        </div>
                                    </div>

                                    {approvalResultdkyxe && (
                                        <BlockDetail title={t("approval-result.infodkyxe")}>
                                            <div className="grid">
                                                <div className="col-12">
                                                    <div className="grid">
                                                        {/* bien so xe */}
                                                        <div className="field col-12 md:col-4">
                                                            <label htmlFor="licensePlate" className="custom-form">
                                                                {t("approval-result.licensePlate")}
                                                            </label>
                                                            <InputText id="licensePlate" value={approvalResultdkyxe?.licensePlate} readOnly className="custom-form" />
                                                        </div>

                                                        {/* loại phương tiện */}
                                                        <div className="field col-12 md:col-4">
                                                            <label htmlFor="vehicleType" className="custom-form">
                                                                {t("approval-result.vehicleType")}
                                                            </label>
                                                            <InputText id="vehicleType" value={approvalResultdkyxe?.vehicleType} readOnly className="custom-form" />
                                                        </div>

                                                        {/* loại xe */}
                                                        <div className="field col-12 md:col-4">
                                                            <label htmlFor="typeVehicle" className="custom-form">
                                                                {t("approval-result.typeVehicle")}
                                                            </label>
                                                            <InputText id="typeVehicle" value={approvalResultdkyxe?.typeVehicle} readOnly className="custom-form" />
                                                        </div>
                                                    </div>

                                                    <div className="grid">
                                                        {/* màu biển số */}
                                                        <div className="field col-12 md:col-4">
                                                            <label htmlFor="colorLicensePlate" className="custom-form">
                                                                {t("approval-result.colorLicensePlate")}
                                                            </label>
                                                            <InputText id="colorLicensePlate" value={approvalResultdkyxe?.colorLicensePlate} readOnly className="custom-form" />
                                                        </div>

                                                        {/* màu xe */}
                                                        <div className="field col-12 md:col-4">
                                                            <label htmlFor="colorVehicle" className="custom-form">
                                                                {t("approval-result.colorVehicle")}
                                                            </label>
                                                            <InputText id="colorVehicle" value={approvalResultdkyxe?.colorVehicle} readOnly className="custom-form" />
                                                        </div>

                                                        {/* số khung */}
                                                        <div className="field col-12 md:col-4">
                                                            <label htmlFor="frameNumber" className="custom-form">
                                                                {t("approval-result.frameNumber")}
                                                            </label>
                                                            <InputText id="frameNumber" value={approvalResultdkyxe?.frameNumber} readOnly className="custom-form" />
                                                        </div>
                                                    </div>

                                                    <div className="grid">
                                                        {/* số máy */}
                                                        <div className="field col-12 md:col-2">
                                                            <label htmlFor="machineNumber" className="custom-form">
                                                                {t("approval-result.machineNumber")}
                                                            </label>
                                                            <InputText id="machineNumber" value={approvalResultdkyxe?.machineNumber} readOnly className="custom-form" />
                                                        </div>

                                                        {/* dung tích */}
                                                        <div className="field col-12 md:col-2">
                                                            <label htmlFor="capacity" className="custom-form">
                                                                {t("approval-result.capacity")}
                                                            </label>
                                                            <InputText id="capacity" value={approvalResultdkyxe?.capacity} readOnly className="custom-form" />
                                                        </div>

                                                        {/* số chỗ ngồi */}
                                                        <div className="field col-12 md:col-2">
                                                            <label htmlFor="numberSeats" className="custom-form">
                                                                {t("approval-result.numberSeats")}
                                                            </label>
                                                            <InputText id="numberSeats" value={approvalResultdkyxe?.numberSeats} readOnly className="custom-form" />
                                                        </div>

                                                        {/* id ho so */}
                                                        <div className="field col-12 md:col-2">
                                                            <label htmlFor="fileId" className="custom-form">
                                                                {t("approval-result.fileId")}
                                                            </label>
                                                            <InputText id="fileId" value={approvalResultdkyxe?.fileId} readOnly className="custom-form" />
                                                        </div>

                                                        {/* ngay nhan ket qua */}
                                                        <div className="field col-12 md:col-4">
                                                            <label htmlFor="receiveDate" className="custom-form">
                                                                {t("approval-result.receiveDate")}
                                                            </label>
                                                            <InputText id="receiveDate" value={approvalResultdkyxe?.createdDate} readOnly className="custom-form" />
                                                        </div>
                                                    </div>

                                                    <div className="grid">
                                                        {/* đơn vị cấp */}
                                                        <div className="field col-12 md:col-4">
                                                            <label htmlFor="unitName" className="custom-form">
                                                                {t("approval-result.unitName2")}
                                                            </label>
                                                            <InputText id="unitName" name="unitName" value={approvalResultdkyxe?.issuedBy} readOnly className="custom-form" tooltip={approvalResultdkyxe.issuedBy} tooltipOptions={{ position: "top" }} />
                                                        </div>

                                                        {/* tên chủ sở hữu */}
                                                        <div className="field col-12 md:col-4">
                                                            <label htmlFor="ownerName" className="custom-form">
                                                                {t("approval-result.ownerName")}
                                                            </label>
                                                            <InputText id="ownerName" name="ownerName" value={approvalResultdkyxe?.ownerName} readOnly className="custom-form" tooltip={approvalResultdkyxe.ownerName} tooltipOptions={{ position: "top" }} />
                                                        </div>

                                                        {/* địa chỉ chủ sở hữu */}
                                                        <div className="field col-12 md:col-4">
                                                            <label htmlFor="ownerAddress" className="custom-form">
                                                                {t("approval-result.ownerAddress")}
                                                            </label>
                                                            <InputText id="ownerAddress" value={approvalResultdkyxe?.ownerAddress} readOnly className="custom-form" tooltip={approvalResultdkyxe.ownerAddress} tooltipOptions={{ position: "top" }} />
                                                        </div>
                                                    </div>

                                                    <div className="grid">
                                                        {/* ký do không đạt */}
                                                        <div className="field col-12 md:col-6">
                                                            <label htmlFor="reasonNotPass" className="custom-form">
                                                                {t("approval-result.reasonNotPass")}
                                                            </label>
                                                            <InputText id="reasonNotPass" value={approvalResultdkyxe?.reasonNotPassContent} readOnly className="custom-form" tooltip={approvalResultdkyxe.reasonNotPassContent} tooltipOptions={{ position: "top" }} />
                                                        </div>

                                                        {/* mô tả lý do */}
                                                        <div className="field col-12 md:col-6">
                                                            <label htmlFor="descriptionReason" className="custom-form">
                                                                {t("approval-result.descriptionReason")}
                                                            </label>
                                                            <InputText id="descriptionReason" value={approvalResultdkyxe?.descriptionReason} readOnly className="custom-form" tooltip={approvalResultdkyxe.descriptionReason} tooltipOptions={{ position: "top" }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </BlockDetail>
                                    )}
                                </TabPanel>
                                <TabPanel header={t("approval-result.gplx")}>
                                    <div className="grid">
                                        <div className="col-12">
                                            <BlockDetail title={t("search", { ns: "common" })}>{searchOptiongplx}</BlockDetail>
                                        </div>
                                    </div>

                                    <div className="grid">
                                        <div className="col-12">
                                            <BlockDetail title={t("approval-result.listgplx")}>
                                                <DataTable
                                                    ref={dt}
                                                    value={approvalResultgplxs}
                                                    dataKey="stt"
                                                    className="datatable-responsive p-datatable-sm"
                                                    selection={approvalResultgplx}
                                                    selectionMode="single"
                                                    onSelectionChange={(e) => {
                                                        setApprovalResultgplx(e.value);
                                                    }}
                                                    showGridlines
                                                    lazy
                                                    paginator
                                                    rows={dataSearchgplx.rows}
                                                    first={dataSearchgplx.first}
                                                    totalRecords={totalRecordgplxs}
                                                    onPage={onPagegplx}
                                                    onSort={onSortgplx}
                                                    sortField={dataSearchgplx.sortField}
                                                    sortOrder={dataSearchgplx.sortOrder}
                                                    onFilter={onFiltergplx}
                                                    filters={dataSearchgplx.filters}
                                                    paginatorClassName="justify-content-start"
                                                    paginatorTemplate={paginatorTemplate}
                                                    emptyMessage="Không có dữ liệu"
                                                    scrollable
                                                >
                                                    <Column field="stt" header={t("stt", { ns: "common" })} style={{ maxWidth: "50px" }} />
                                                    <Column field="idNumber" header={t("approval-result.idNumber")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="documentCode" header={t("approval-result.documentCode1")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="enabled" header={t("approval-result.enabled")} body={checkboxBodyTemplate} style={{ minWidth: "100px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="approvalDate" header={t("approval-result.approvalDate1")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="approvalResults" header={t("approval-result.approvalResults")} body={templateApprovalResult} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="approvalDate" header={t("approval-result.approvalDate")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                </DataTable>
                                            </BlockDetail>
                                        </div>
                                    </div>

                                    {approvalResultgplx && (
                                        <BlockDetail title={t("approval-result.infogplx")}>
                                            <div className="grid">
                                                <div className="col-12">
                                                    <div className="grid">
                                                        {/* loại phuong tiện */}
                                                        <div className="field col-12 md:col-2">
                                                            <label htmlFor="vehicleType" className="custom-form">
                                                                {t("approval-result.vehicleType")}
                                                            </label>
                                                            <InputText id="vehicleType" value={approvalResultgplx?.vehicleType} readOnly className="custom-form" />
                                                        </div>

                                                        {/* hạng */}
                                                        <div className="field col-12 md:col-2">
                                                            <label htmlFor="grade" className="custom-form">
                                                                {t("approval-result.grade")}
                                                            </label>
                                                            <InputText id="grade" value={approvalResultgplx?.grade} readOnly className="custom-form" />
                                                        </div>

                                                        {/* Số phôi */}
                                                        <div className="field col-12 md:col-2">
                                                            <label htmlFor="numberOfEmbryos" className="custom-form">
                                                                {t("approval-result.numberOfEmbryos")}
                                                            </label>
                                                            <InputText id="numberOfEmbryos" value={approvalResultgplx?.numberOfEmbryos} readOnly className="custom-form" />
                                                        </div>

                                                        {/* ngay trung tuyen */}
                                                        <div className="field col-12 md:col-2">
                                                            <label htmlFor="passDay" className="custom-form">
                                                                {t("approval-result.passDay")}
                                                            </label>
                                                            <InputText id="passDay" value={approvalResultgplx?.passDay} readOnly className="custom-form" />
                                                        </div>

                                                        {/* ngay het han */}
                                                        <div className="field col-12 md:col-2">
                                                            <label htmlFor="expirationDate" className="custom-form">
                                                                {t("approval-result.expirationDate1")}
                                                            </label>
                                                            <InputText id="expirationDate" value={approvalResultgplx?.expirationDate} readOnly className="custom-form" />
                                                        </div>

                                                        {/* ho so id */}
                                                        <div className="field col-12 md:col-2">
                                                            <label htmlFor="fileId" className="custom-form">
                                                                {t("approval-result.fileId")}
                                                            </label>
                                                            <InputText id="fileId" value={approvalResultgplx?.fileId} readOnly className="custom-form" />
                                                        </div>
                                                    </div>

                                                    <div className="grid">
                                                        {/* đơn vị cấp */}
                                                        <div className="field col-12 md:col-4">
                                                            <label htmlFor="unitName" className="custom-form">
                                                                {t("approval-result.unitName2")}
                                                            </label>
                                                            <InputText id="unitName" value={approvalResultgplx?.issuedBy} readOnly className="custom-form" tooltip={approvalResultgplx.issuedBy} tooltipOptions={{ position: "top" }} />
                                                        </div>

                                                        {/* họ và tên */}
                                                        <div className="field col-12 md:col-4">
                                                            <label htmlFor="ownerName" className="custom-form">
                                                                {t("approval-result.ownerName1")}
                                                            </label>
                                                            <InputText id="ownerName" name="ownerName" value={approvalResultgplx?.ownerName} readOnly className="custom-form" tooltip={approvalResultgplx.ownerName} tooltipOptions={{ position: "top" }} />
                                                        </div>

                                                        {/* ngay sinh */}
                                                        <div className="field col-12 md:col-2">
                                                            <label htmlFor="birthDate" className="custom-form">
                                                                {t("approval-result.birthDate")}
                                                            </label>
                                                            <InputText id="birthDate" name="birthDate" value={approvalResultgplx?.birthDate} readOnly className="custom-form" />
                                                        </div>
                                                        {/* ngay nhan ket qua */}
                                                        <div className="field col-12 md:col-2">
                                                            <label htmlFor="receiveDate" className="custom-form">
                                                                {t("approval-result.receiveDate")}
                                                            </label>
                                                            <InputText id="receiveDate" value={approvalResultgplx?.createdDate} name="approvalDate" readOnly className="custom-form" />
                                                        </div>
                                                    </div>

                                                    <div className="grid">
                                                        {/* ký do không đạt */}
                                                        <div className="field col-12 md:col-6">
                                                            <label htmlFor="reasonNotPass" className="custom-form">
                                                                {t("approval-result.reasonNotPass")}
                                                            </label>
                                                            <InputText id="reasonNotPass" value={approvalResultgplx?.reasonNotPassContent} readOnly className="custom-form" tooltip={approvalResultgplx.reasonNotPassContent} tooltipOptions={{ position: "top" }} />
                                                        </div>

                                                        {/* mô tả lý do */}
                                                        <div className="field col-12 md:col-6">
                                                            <label htmlFor="descriptionReason" className="custom-form">
                                                                {t("approval-result.descriptionReason")}
                                                            </label>
                                                            <InputText id="descriptionReason" value={approvalResultgplx?.descriptionReason} readOnly className="custom-form" tooltip={approvalResultgplx.descriptionReason} tooltipOptions={{ position: "top" }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </BlockDetail>
                                    )}
                                </TabPanel>
                                <TabPanel header={t("approval-result.mst")}>
                                    <div className="grid">
                                        <div className="col-12">
                                            <BlockDetail title={t("search", { ns: "common" })}>{searchOptionthuecn}</BlockDetail>
                                        </div>
                                    </div>

                                    <div className="grid">
                                        <div className="col-12">
                                            <BlockDetail title={t("approval-result.listmst")}>
                                                <DataTable
                                                    ref={dt}
                                                    value={approvalResultmsts}
                                                    dataKey="stt"
                                                    className="datatable-responsive p-datatable-sm"
                                                    showGridlines
                                                    lazy
                                                    paginator
                                                    selection={approvalResultmst}
                                                    selectionMode="single"
                                                    onSelectionChange={(e) => {
                                                        setApprovalResultmst(e.value);
                                                    }}
                                                    rows={dataSearchmst.rows}
                                                    first={dataSearchmst.first}
                                                    totalRecords={totalRecordthuecns}
                                                    onPage={onPagethuecn}
                                                    onSort={onSortthuecn}
                                                    sortField={dataSearchmst.sortField}
                                                    sortOrder={dataSearchmst.sortOrder}
                                                    onFilter={onFilterthuecn}
                                                    filters={dataSearchmst.filters}
                                                    paginatorClassName="justify-content-start"
                                                    paginatorTemplate={paginatorTemplate}
                                                    emptyMessage="Không có dữ liệu"
                                                    scrollable
                                                >
                                                    <Column field="stt" header={t("stt", { ns: "common" })} style={{ maxWidth: "50px" }} />
                                                    <Column field="idNumber" header={t("approval-result.idNumber")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="taxCode" header={t("approval-result.taxCode")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="enabled" header={t("approval-result.enabled")} body={checkboxBodyTemplate} style={{ minWidth: "100px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="issuedOn" header={t("approval-result.issuedOn")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="approvalResults" header={t("approval-result.approvalResults")} body={templateApprovalResult} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="approvalDate" header={t("approval-result.approvalDate")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                </DataTable>
                                            </BlockDetail>
                                        </div>
                                    </div>

                                    {approvalResultmst && (
                                        <BlockDetail title={t("approval-result.infomst")}>
                                            <div className="grid">
                                                <div className="col-12">
                                                    <div className="grid">
                                                        {/* co quan quan ly */}
                                                        <div className="field col-12 md:col-6">
                                                            <label htmlFor="unitName" className="custom-form">
                                                                {t("approval-result.unitName")}
                                                            </label>
                                                            <InputText id="unitName" value={approvalResultmst?.unitName} readOnly className="custom-form" tooltip={approvalResultmst.unitName} tooltipOptions={{ position: "top" }} />
                                                        </div>

                                                        {/* dia chi */}
                                                        <div className="field col-12 md:col-6">
                                                            <label htmlFor="address" className="custom-form">
                                                                {t("approval-result.address")}
                                                            </label>
                                                            <InputText id="address" name="address" value={approvalResultmst?.address} readOnly className="custom-form" tooltip={approvalResultmst.address} tooltipOptions={{ position: "top" }} />
                                                        </div>
                                                    </div>

                                                    <div className="grid">
                                                        {/* trang thai mst */}
                                                        <div className="field col-12 md:col-8">
                                                            <label htmlFor="status" className="custom-form">
                                                                {t("approval-result.status")}
                                                            </label>
                                                            <InputText id="status" value={approvalResultmst?.status} readOnly className="custom-form" />
                                                        </div>

                                                        {/* id ho so */}
                                                        <div className="field col-12 md:col-2">
                                                            <label htmlFor="fileId" className="custom-form">
                                                                {t("approval-result.fileId")}
                                                            </label>
                                                            <InputText id="fileId" value={approvalResultmst?.fileId} readOnly className="custom-form" />
                                                        </div>

                                                        {/* ngay nhan kq */}
                                                        <div className="field col-12 md:col-2">
                                                            <label htmlFor="receiveDate" className="custom-form">
                                                                {t("approval-result.receiveDate")}
                                                            </label>
                                                            <InputText id="receiveDate" value={approvalResultmst?.createdDate} readOnly className="custom-form" />
                                                        </div>
                                                    </div>

                                                    <div className="grid">
                                                        {/* ly do khong dat */}
                                                        <div className="field col-12 md:col-6">
                                                            <label htmlFor="reasonNotPass" className="custom-form">
                                                                {t("approval-result.reasonNotPass")}
                                                            </label>
                                                            <InputText id="reasonNotPass" value={approvalResultmst?.reasonNotPassContent} readOnly className="custom-form" tooltip={approvalResultmst.reasonNotPassContent} tooltipOptions={{ position: "top" }} />
                                                        </div>

                                                        {/* mo ta ly do */}
                                                        <div className="field col-12 md:col-6">
                                                            <label htmlFor="descriptionReason" className="custom-form">
                                                                {t("approval-result.descriptionReason")}
                                                            </label>
                                                            <InputText id="descriptionReason" value={approvalResultmst?.descriptionReason} readOnly className="custom-form" tooltip={approvalResultmst.descriptionReason} tooltipOptions={{ position: "top" }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </BlockDetail>
                                    )}
                                </TabPanel>
                            </TabView>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
